// src/lib/odmiana.js
// Polska odmiana rzeczownika przez liczebnik.
//
// Reguła: 1 -> liczba pojedyncza (1 obiekt), końcówki 2-4 -> mianownik liczby
// mnogiej (2 obiekty, 23 obiekty), reszta -> dopełniacz (5 obiektów).
// Wyjątkiem są nastki: 12, 13 i 14 obiektów, a nie „obiekty”.

export const odmien = (count, [one, few, many]) => {
  const n = Math.abs(count);
  if (n === 1) return one;
  const last = n % 10;
  const lastTwo = n % 100;
  if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return few;
  return many;
};

/**
 * Liczba razem z odmienionym rzeczownikiem, np. „2 obiekty”.
 *
 * UWAGA: to jest forma mianownikowa. Po wyrazach rządzących dopełniaczem
 * („zestawienie…”, „ranking…”, „baza…”) rzeczownik stoi w dopełniaczu
 * niezależnie od liczebnika - tam wpisuje się „obiektów” na sztywno,
 * bo „ranking 42 obiekty” byłoby błędem.
 */
export const zLiczba = (count, forms) => `${count} ${odmien(count, forms)}`;

export const OBIEKTY_FORMS = ['obiekt', 'obiekty', 'obiektów'];
export const OPINIE_FORMS = ['opinia', 'opinie', 'opinii'];
export const MIEJSCOWOSCI_FORMS = ['miejscowość', 'miejscowości', 'miejscowości'];
export const POZYCJE_FORMS = ['pozycja', 'pozycje', 'pozycji'];
export const STRZELNICE_FORMS = ['strzelnica', 'strzelnice', 'strzelnic'];

export default odmien;
